module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19n3uxF/tc-custom/9781685506568.jpg?1726574163277",
      "alt": "This image is the cover for the book Sunrise: Whitney"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sunrise: Whitney\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("You are cordially invited to view one of a  triptych of stories involving the lives and loves of gay men who work or volunteer at the Sunrise Arts Center in Stafford, North Carolina."), _c('br'), _c('br'), _vm._v("When Dr. Whitney Pell's relationship with his long-term partner comes to a surprising and acrimonious end, Whitney decides a change of scene is in order. Becoming the director of an arts center close to where he grew up seems like the perfect opportunity for a fresh start."), _c('br'), _c('br'), _vm._v("Whitney is busy at his new job, enjoying the challenge. He soon finds a house he likes. His personal life is less settled however. Hurt at the breakup of his previous relationship, Whitney enjoys playing the field ... for a while. Then he begins to miss being part of a couple. But finding Mr. Right isn't as easy as finding a house or settling into his new job."), _c('br'), _c('br'), _vm._v("Whitney feels an immediate attraction to Stuart Blount, the hunky  art teacher at the local high school. However, the wedding band on Stuart's finger indicates he's married and probably straight. Things between Stuart and Whitney continue to hot up, and Whitney learns more about Stuart's past, showing he isn't as straight as Whitney first believed. But will Whitney's present cause the picture of domestic bliss they're painting to be torn apart?"), _c('br'), _c('br'), _vm._v("Note: This story has a minor character discusses past physical abuse from a former partner.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tim Mead\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0